/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import classNames from 'classnames/bind';
import { useMutation } from '@apollo/client';
import { Button } from '../../components';
import { FancyField } from '../../components/fancyFieldsV2';
import { UPDATE_PASSWORD_MUTATION } from './ACCOUNT_FORMS_MUTATIONS_AND_QUERIES';
import styles from './styles.module.scss';
import { useAlertMessage } from '../../hooks';

const cx = classNames.bind(styles);

interface Props {
  cancel: () => void;
}

const PasswordForm = ({ cancel }: Props) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const [updatePasswordMutation] = useMutation(UPDATE_PASSWORD_MUTATION);

  const { showSuccess, showError } = useAlertMessage();

  const updatePassword = async () => {
    try {
      await updatePasswordMutation({
        variables: {
          currentPassword,
          newPassword,
        },
      });
      showSuccess('Successfully updated password.');
    } catch (error) {
      showError(error);
    }
  };

  const valid = () => currentPassword.length > 3 && newPassword.length > 3;

  return (
    <div className={cx('account-form', 'password-form')}>
      <div className={cx('fields-wrap')}>
        <label>Current Password</label>
        <FancyField
          noLabel
          grey
          initFocus
          value={currentPassword}
          type="password"
          placeholder="Current Password"
          onChange={(value: string) => setCurrentPassword(value)}
        />
        <label className="mt-3">New Password</label>
        <FancyField
          noLabel
          grey
          value={newPassword}
          type="password"
          placeholder="New Password"
          onChange={(value: string) => setNewPassword(value)}
        />
      </div>
      <Button onClick={updatePassword} action disabled={!valid()} wide>
        Save
      </Button>
      <br />
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events */}
      <a className={cx('cancel-button')} onClick={cancel} role="link" tabIndex={0}>
        Back
      </a>
    </div>
  );
};

export default PasswordForm;
